import { createStyles, rem } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  root: {},
}))
